import React, { Fragment } from 'react';
import TemplateGroupRow from '../TemplateGroupRow';
import StopRow from '../StopRow';
import PropTypes from 'prop-types';

function TemplateGroup(props) {
  const {
    stops,
    selectedStops,
    onSelectStop,
    onSelectGroup,
    isCollapsed,
    toggleCollapsed,
    columnConfigs,
    template,
    templateSelected,
    groupContent,
    shouldStopsHover,
  } = props;

  return (
    <Fragment key={template ? template.id : 'unassigned'}>
      <TemplateGroupRow
        isCollapsed={isCollapsed}
        onClick={onSelectGroup}
        selected={templateSelected}
        toggle={toggleCollapsed}
        columnConfigs={columnConfigs}
        content={groupContent}
        color={template?.color}
      />
      {!isCollapsed &&
        stops.map((stop) => (
          <StopRow
            columnConfigs={columnConfigs}
            isSelected={selectedStops.findIndex((c) => c.id === stop.id) >= 0}
            key={stop.id}
            onClick={() =>
              onSelectStop({
                templateStops: [stop],
                unselect: selectedStops.findIndex((c) => c.id === stop.id) >= 0,
              })
            }
            stop={stop}
            shouldHover={shouldStopsHover}
          />
        ))}
    </Fragment>
  );
}

TemplateGroup.propTypes = {
  stops: PropTypes.array.isRequired,
  selectedStops: PropTypes.array.isRequired,
  onSelectStop: PropTypes.func.isRequired,
  onSelectGroup: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool,
  toggleCollapsed: PropTypes.func.isRequired,
  columnConfigs: PropTypes.array.isRequired,
  template: PropTypes.object,
  templateSelected: PropTypes.bool.isRequired,
  groupContent: PropTypes.node.isRequired,
  shouldStopsHover: PropTypes.bool,
};

export default TemplateGroup;
